import React, { useEffect } from 'react';
import pdfIcon from '../../assets/images/pdfIcons.svg';
import docIcon from '../../assets/images/docIcon.svg';
import IconArrow from '../../assets/images/Vector (5).svg';
import firstine from '../../assets/icons/file-list.svg';
import user1 from '../../assets/icons/user.svg';
import stetho from '../../assets/icons/stethoscope.svg';
import first from '../../assets/icons/first-aid.svg';
import briefcase2 from '../../assets/icons/briefcase-2-line.svg';
import graduation from '../../assets/icons/graduation-cap-line.svg';
import suitcase from '../../assets/icons/suitcase-line.svg';
import firstKit from '../../assets/icons/first-aid-kit.svg';
import arrowgo from '../../assets/icons/arrowgo.svg';
import apiService from '../../services/apiService';
import ProfilePhysician from '../profilePhysician/ProfilePhysician';

const DetailFormProfile = ({ id }) => {
  const [values, setValues] = React.useState();

  const [isToggled, setIsToggled] = React.useState(false);

  const handleToggle = () => {
    setIsToggled(!isToggled); // Toggle the state
  };

  const fetchData = async (id) => {
    const response = await apiService.get(`/physician/showPhysician/${id}`);

    setValues(response?.physician);
  };

  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));

    fetchData(user?.physician_id);
  }, [isToggled]);

  return (
    <>
      <div className="p-5">
        <div className="flex justify-end pb-3">
          {isToggled ? (
            <button
              type="button"
              onClick={handleToggle}
              id="dashboard-tab"
              data-tabs-target="#dashboard"
              role="tab"
              aria-controls="dashboard"
              className="text-white bg-[#007A63] flex justify-between items-center focus:ring-4 focus:outline-none w-[160px] h-[50px] font-medium rounded-lg text-sm px-4 py-2.5 text-center"
            >
              <>
                <span className="flex-grow text-center">Cancel</span>
              </>
            </button>
          ) : (
            <button
              type="button"
              onClick={handleToggle}
              id="dashboard-tab"
              data-tabs-target="#dashboard"
              role="tab"
              aria-controls="dashboard"
              className="text-white bg-[#007A63] flex justify-between items-center focus:ring-4 focus:outline-none w-[160px] h-[50px] font-medium rounded-lg text-sm px-4 py-2.5 text-center"
            >
              <>
                <img src={IconArrow} alt="logo" className="" />
                <span className="flex-grow text-center">Edit Profile</span>
              </>
            </button>
          )}
        </div>
        {!isToggled ? (
          <div
            className=" text-medium text-gray-500   rounded-lg w-full"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="border-t border-l">
              <div className="bg-[#E2E4E9] h-[72px] flex items-center">
                <div className="pl-4 flex  space-x-1 items-center">
                  <div className="">
                    <img
                      src={firstine}
                      alt="License Icon"
                      className="w-6 h-6 "
                    />
                  </div>
                  <h3 className="label-medium pt-2">License Information</h3>
                </div>
              </div>

              <div className=" pt-1 ml-4 ">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6 ">
                  <div className="lg:col-span-1 border-r">
                    <div>
                      <label className="inter-font2">
                        SCFHS License Number
                      </label>
                      <div className="text-[#0A0D14] inter-font">
                        {values?.licenseNumber}
                      </div>
                    </div>
                  </div>
                  <div className="lg:col-span-1 border-r">
                    <div className="flex flex-col items-center justify-center">
                      <div>
                        <label className="inter-font2">
                          SCFHS License Expiry Date
                        </label>
                        <div className="text-[#DF1C41] inter-font">
                          {values?.licenseExpiryDate}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="lg:col-span-1"></div>
                </div>
              </div>
              <div className="bg-[#E2E4E9] h-[72px] flex items-center">
                <div className="pl-4 flex items-center space-x-1 ">
                  <div className=" ">
                    <img src={user1} alt="License Icon" className="w-6 h-6" />
                  </div>
                  <h3 className="label-medium pt-2">
                    Practitioner Information
                  </h3>
                </div>
              </div>

              <div className="pt-1 ml-4">
                {/* First Row: Two Columns */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 pt-6 pb-6">
                  <div className="lg:col-span-1 border-r">
                    <label className="inter-font2">Arabic Name</label>
                    <div className="text-[#0A0D14] inter-font">
                      {values?.firstArabicName}
                    </div>
                  </div>
                  <div className="lg:col-span-1">
                    <label className="inter-font2">English Name</label>
                    <div className="text-[#0A0D14] inter-font">
                      {values?.user?.firstName}
                    </div>
                  </div>
                </div>
                <hr />

                {/* Second Row: Three Columns */}

                {/* Third Row: Three Columns */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                  <div className="lg:col-span-1 border-r">
                    <label className="inter-font2">Nationality</label>
                    <div className="text-[#0A0D14] inter-font">
                      {values?.nationality}
                    </div>
                  </div>
                  <div className="lg:col-span-1 border-r">
                    <label className="inter-font2">Identity #</label>
                    <div className="text-[#0A0D14] inter-font">
                      {values?.identityNumber}
                    </div>
                  </div>
                  <div className="lg:col-span-1"></div>
                </div>
                <hr />

                {/* Fourth Row: Three Columns */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                  <div className="lg:col-span-1 border-r">
                    <label className="inter-font2">Date of Birth</label>
                    <div className="text-[#0A0D14] inter-font">
                      {values?.dateOfBirth}
                    </div>
                  </div>
                  <div className="lg:col-span-1 border-r">
                    <label className="inter-font2">Place Of Birth</label>
                    <div className="text-[#0A0D14] inter-font">
                      {values?.placeOfBirth}
                    </div>
                  </div>
                  <div className="lg:col-span-1">
                    <label className="inter-font2">Gender</label>
                    <div className="text-[#0A0D14] inter-font">
                      {values?.gender}
                    </div>
                  </div>
                </div>
                <hr />
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                  <div className="lg:col-span-1 border-r">
                    <label className="inter-font2">Email</label>
                    <div className="text-[#0A0D14] inter-font">
                      {values?.user?.email}
                    </div>
                  </div>
                  <div className="lg:col-span-1 border-r">
                    <label className="inter-font2">Phone Number</label>
                    <div className="text-[#0A0D14] inter-font">
                      {values?.user?.phoneNumber}
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-[#E2E4E9] h-[72px] flex items-center">
                <div className="flex items-center space-x-1 ">
                  <div className="pl-4">
                    <img src={stetho} alt="License Icon" className="w-6 h-6" />
                  </div>

                  <h3 className="label-medium pt-2">Personal Information</h3>
                </div>
              </div>

              <div className=" pt-1 ml-4 ">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                  <div className="lg:col-span-1 border-r">
                    <div>
                      <label className="inter-font2">Practitioner Type</label>
                      <div className="text-[#0A0D14] inter-font">
                        {values?.practitionerType}
                      </div>
                    </div>
                  </div>
                  <div className="lg:col-span-1">
                    <div>
                      <label className="inter-font2">Practitioner Level</label>
                      <div className="text-[#0A0D14] inter-font">
                        {values?.practitionerLevels}
                      </div>
                    </div>
                  </div>
                  <div className="lg:col-span-1">
                    <div></div>
                  </div>
                </div>
              </div>

              <div className="bg-[#E2E4E9] h-[72px] flex items-center">
                <div className="flex items-center space-x-1 ">
                  <div className="pl-4">
                    <img src={first} alt="License Icon" className="w-6 h-6 " />
                  </div>
                  <h3 className="label-medium pt-2">Medical Specialties</h3>
                </div>
              </div>

              <div className=" pt-1 ml-4 ">
                <div className="flex gap-4 pt-7 pb-7">
                  {values?.related_medical_specialties?.map((label, index) => (
                    <span
                      key={index}
                      className="cursor-pointer leading-[16px] text-[12px] text-xs font-medium px-2.5 py-0.5 rounded border h-[24px] bg-[#2D9F75] text-[#fff] border-[#E2E4E9]"
                    >
                      {label?.name}
                    </span>
                  ))}
                </div>
              </div>

              <div className="bg-[#E2E4E9] h-[72px] flex items-center">
                <div className="flex items-center space-x-1 ">
                  <div className="pl-4">
                    <img
                      src={briefcase2}
                      alt="License Icon"
                      className="w-6 h-6"
                    />
                  </div>

                  <h3 className="label-medium pt-2">Job Information</h3>
                </div>
              </div>

              <div className=" pt-1 ml-4 ">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                  <div className="lg:col-span-1 border-r">
                    <div>
                      <label className="inter-font2">
                        Current Job Organisation
                      </label>
                      <div className="text-[#0A0D14]">
                        {values?.currentJobOrganization}
                      </div>
                    </div>
                  </div>
                  <div className="lg:col-span-1">
                    <div>
                      <label className="inter-font2">Current Job Title</label>
                      <div className="text-[#0A0D14]">
                        {values?.currentJobTitle}
                      </div>
                    </div>
                  </div>

                  <div className="lg:col-span-1">
                    <div>
                      <label className="inter-font2">Hospital Preference</label>
                      <div className="text-[#0A0D14]">
                        {values?.sites?.map((file) => {
                          return (
                            <div
                              key={file.value} // Use a unique key, assuming `file.value` is unique
                              className="bg-[#F0F4F8] p-2 mb-2 rounded-md w-[185px] truncate"
                              title={file.label}
                            >
                              {file?.name}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>

                  <div className="lg:col-span-1">
                    <div>
                      <label className="inter-font2">Hospital Preference</label>
                      <div className="text-[#0A0D14]">
                        {values?.siteIds?.map((file) => {
                          return (
                            <div
                              key={file.value} // Use a unique key, assuming `file.value` is unique
                              className="bg-[#F0F4F8] p-2 mb-2 rounded-md w-[185px] truncate"
                              title={file.label}
                            >
                              {file.label}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-[#E2E4E9] h-[72px] flex items-center">
                <div className="flex items-center space-x-1 ">
                  <div className="pl-4">
                    <img
                      src={graduation}
                      alt="License Icon"
                      className="w-6 h-6"
                    />
                  </div>

                  <h3 className="label-medium pt-2">Education Documents</h3>
                </div>
              </div>

              <div className=" pt-1 ml-4 ">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                  {values?.educationDocument?.map((file) => {
                    const filePath = file?.path || file;
                    const fileExtension = filePath
                      ?.split?.('.')
                      ?.pop()
                      ?.toLowerCase(); // Get the file extension

                    let fileIcon = null;

                    // Check file type and assign the appropriate icon
                    if (fileExtension === 'pdf') {
                      fileIcon = pdfIcon; // Set PDF icon
                    } else if (
                      fileExtension === 'doc' ||
                      fileExtension === 'docx'
                    ) {
                      fileIcon = docIcon; // Set DOC icon
                    }
                    return (
                      <div
                        key={file.path}
                        className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                      >
                        {fileIcon && (
                          <img
                            src={fileIcon}
                            alt="file icon"
                            className="w-[40px] h-[40px] flex-shrink-0"
                          />
                        )}

                        <div className="flex flex-col w-full">
                          <div className="flex justify-between items-center w-full">
                            <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                              {filePath}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="bg-[#E2E4E9] h-[72px] flex items-center">
                <div className="flex items-center space-x-1 ">
                  <div className="pl-4">
                    <img
                      src={suitcase}
                      alt="License Icon"
                      className="w-6 h-6 "
                    />
                  </div>

                  <h3 className="label-medium pt-2">Experience Documents</h3>
                </div>
              </div>

              <div className=" pt-1 ml-4 ">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                  {values?.experienceDocument?.map((file) => {
                    const filePath = file?.path || file;
                    const fileExtension = filePath
                      ?.split?.('.')
                      ?.pop()
                      ?.toLowerCase(); // Get the file extension

                    let fileIcon = null;

                    // Check file type and assign the appropriate icon
                    if (fileExtension === 'pdf') {
                      fileIcon = pdfIcon; // Set PDF icon
                    } else if (
                      fileExtension === 'doc' ||
                      fileExtension === 'docx'
                    ) {
                      fileIcon = docIcon; // Set DOC icon
                    }
                    return (
                      <div
                        key={file.path}
                        className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                      >
                        {fileIcon && (
                          <img
                            src={fileIcon}
                            alt="file icon"
                            className="w-[40px] h-[40px] flex-shrink-0"
                          />
                        )}

                        <div className="flex flex-col w-full">
                          <div className="flex justify-between items-center w-full">
                            <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                              {filePath}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="bg-[#E2E4E9] h-[72px] flex items-center">
                <div className="flex items-center space-x-1 ">
                  <div className="pl-4">
                    <img
                      src={firstKit}
                      alt="License Icon"
                      className="w-6 h-6"
                    />
                  </div>

                  <h3 className="label-medium pt-2">
                    Practitioner Specialties Documents
                  </h3>
                </div>
              </div>

              <div className=" pt-1 ml-4 ">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                  {values?.practitionerSpecialtiesDocuments?.map((file) => {
                    const filePath = file?.path || file;
                    const fileExtension = filePath
                      ?.split?.('.')
                      ?.pop()
                      ?.toLowerCase(); // Get the file extension

                    let fileIcon = null;

                    // Check file type and assign the appropriate icon
                    if (fileExtension === 'pdf') {
                      fileIcon = pdfIcon; // Set PDF icon
                    } else if (
                      fileExtension === 'doc' ||
                      fileExtension === 'docx'
                    ) {
                      fileIcon = docIcon; // Set DOC icon
                    }
                    return (
                      <div
                        key={file.path}
                        className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                      >
                        {fileIcon && (
                          <img
                            src={fileIcon}
                            alt="file icon"
                            className="w-[40px] h-[40px] flex-shrink-0"
                          />
                        )}

                        <div className="flex flex-col w-full">
                          <div className="flex justify-between items-center w-full">
                            <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                              {filePath}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {values?.requestAttachments.length > 0 && (
                <>
                  <div className="bg-[#E2E4E9] h-[72px] flex items-center">
                    <div className="flex items-center space-x-1 ">
                      <div className="pl-4">
                        <img
                          src={arrowgo}
                          alt="License Icon"
                          className="w-6 h-6"
                        />
                      </div>
                      <h3 className="label-medium pt-2">
                        Additional Attachments
                      </h3>
                    </div>
                  </div>

                  <div className=" pt-1 ml-4 ">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                      {values?.requestAttachments?.map((file) => {
                        const filePath = file?.path || file;
                        const fileExtension = filePath
                          ?.split?.('.')
                          ?.pop()
                          ?.toLowerCase(); // Get the file extension

                        let fileIcon = null;

                        // Check file type and assign the appropriate icon
                        if (fileExtension === 'pdf') {
                          fileIcon = pdfIcon; // Set PDF icon
                        } else if (
                          fileExtension === 'doc' ||
                          fileExtension === 'docx'
                        ) {
                          fileIcon = docIcon; // Set DOC icon
                        }
                        return (
                          <div
                            key={file.path}
                            className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                          >
                            {fileIcon && (
                              <img
                                src={fileIcon}
                                alt="file icon"
                                className="w-[40px] h-[40px] flex-shrink-0"
                              />
                            )}

                            <div className="flex flex-col w-full">
                              <div className="flex justify-between items-center w-full">
                                <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                                  {filePath}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        ) : (
          <ProfilePhysician
            physician_id={user?.physician_id}
            handleToggle={handleToggle}
          />
        )}
      </div>
    </>
  );
};

export default DetailFormProfile;
